import script from "./Feanor-TeoriaView.vue?vue&type=script&setup=true&lang=js"
export * from "./Feanor-TeoriaView.vue?vue&type=script&setup=true&lang=js"

import "./Feanor-TeoriaView.vue?vue&type=style&index=0&id=0da9df8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da9df8d"]])

export default __exports__